import moment from 'moment-timezone'

export const CALENDAR_RANGE_VIEWS = ['month', 'quarter', 'year']

function asMoment(date, timezone) {
    if (timezone) return moment.tz(date, timezone)
    return moment(date)
}

export function getCalendarBounds(date, view, timezone) {
    const d = asMoment(date, timezone)
    if (view === 'year') {
        return {
            start: d.clone().startOf('year'),
            end: d.clone().endOf('year')
        }
    }
    if (view === 'quarter') {
        return {
            start: d.clone().startOf('quarter'),
            end: d.clone().endOf('quarter')
        }
    }
    return {
        start: d.clone().startOf('month'),
        end: d.clone().endOf('month')
    }
}

export function shiftCalendarCursor(date, view, direction, timezone) {
    const d = asMoment(date, timezone)
    const amount = direction < 0 ? -1 : 1
    if (view === 'year') return d.clone().add(amount, 'year').startOf('year')
    if (view === 'quarter')
        return d
            .clone()
            .add(amount * 3, 'month')
            .startOf('quarter')
    return d.clone().add(amount, 'month').startOf('month')
}

export function getMonthsInView(date, view, timezone) {
    const bounds = getCalendarBounds(date, view, timezone)
    const months = []
    const cursor = bounds.start.clone().startOf('month')
    const last = bounds.end.clone().startOf('month')
    while (cursor.isSameOrBefore(last, 'month')) {
        months.push(cursor.clone())
        cursor.add(1, 'month')
    }
    return months
}

export function formatCalendarTitle(date, view, locale, timezone) {
    const d = asMoment(date, timezone)
    if (locale) d.locale(locale)
    if (view === 'year') return d.format('YYYY')
    if (view === 'quarter') {
        const start = d.clone().startOf('quarter')
        const end = d.clone().endOf('quarter')
        if (locale) {
            start.locale(locale)
            end.locale(locale)
        }
        return `${start.format('MMM')} – ${end.format('MMM')} ${d.format('YYYY')}`
    }
    return `${d.format('MMMM')} - ${d.format('YYYY')}`
}

export function indexEventsByDay(events, userTimezone) {
    const map = {}
    ;(events || []).forEach((e) => {
        const start = moment.utc(e.start).tz(userTimezone).startOf('day')
        const end = e.end ? moment.utc(e.end).tz(userTimezone).startOf('day') : start.clone()
        const cursor = start.clone()
        let steps = 0
        while (cursor.isSameOrBefore(end, 'day') && steps < 366) {
            const key = cursor.format('YYYY-MM-DD')
            if (!map[key]) map[key] = []
            map[key].push(e)
            cursor.add(1, 'day')
            steps += 1
        }
    })
    Object.keys(map).forEach((key) => {
        map[key].sort((a, b) => a.start - b.start)
    })
    return map
}

export function buildMonthWeeks(monthMoment, eventsByDay, userTimezone) {
    const _year = monthMoment.year() + ''
    const _month = (monthMoment.month() + 1 + '').padStart(2, '0')
    const weeks = []
    let week = {}
    weeks.push(week)
    const day = moment.tz(_year + '/' + _month, 'YYYY/MM', userTimezone).startOf('month')
    let weekDay = day.weekday()
    week[weekDay] = {
        entries: eventsByDay[day.format('YYYY-MM-DD')] || [],
        date: day.clone(),
        day: day.format('ddd'),
        dateStr: day.format('D')
    }
    day.add(1, 'day')
    while (day.date() > 1) {
        weekDay = day.weekday()
        if (weekDay === 0) {
            const newWeek = {}
            weeks.push(newWeek)
            week = newWeek
        }
        week[weekDay] = {
            entries: eventsByDay[day.format('YYYY-MM-DD')] || [],
            date: day.clone(),
            day: day.format('ddd'),
            dateStr: day.format('D')
        }
        day.add(1, 'day')
    }
    return weeks
}
